import React from "react";
import Card from "react-bootstrap/Card";
// import IconButton from '@mui/material/IconButton';
import { Row, Col } from "react-bootstrap";
import readmore from "../../Assets/Work/readmore.svg";
import './Work.css';

function WorkCards(props) {
  
  return (
    <Card className="work-card-view">
      <Row className="work-row" style={{paddingBottom: '20px', paddingTop: '20px'}}>
      <Col sm={6}>
      <Card.Body>
        <Card.Img src={props.imgWay} alt="card-img" />
      </Card.Body>
      </Col>
     
      
      <Col sm={5}>
          <Card.Body> 
        <div className="bottom">
       
        <Card.Title className="wtitle">{props.title}</Card.Title>
        <Card.Title className="role">{props.role}</Card.Title>
        <Card.Title className="content">{props.description}</Card.Title>
        </div>
        <div className="readmore">
          
        <span className="hide">Read More</span> <img className="rm-img" alt="readmore-img" src={readmore} />
        </div>
        </Card.Body>
        </Col>
        
        
      
      </Row> 
    </Card>
  );
}
export default WorkCards;
